/**
* @author Edgar Escobedo
* @description Splice a string with 100 letters or more and add ...
* @updatedDate 16 -03-2023
* @param {Number} String 
* @returns {String}
*/

function sliceString100AndAddPoints(cadena){
    const textSLice = cadena.slice(0, 100).trim();
    const newText = `${textSLice}...`
    return newText
}

export {sliceString100AndAddPoints}